const initFaqs = () => {
  const faqSectionEls = document.querySelectorAll('[data-faqs-section]');

  faqSectionEls.forEach(section => {
    const toggleEl = section.querySelector('[data-faq-toggle]');
    const hiddenFaqEls = section.querySelectorAll('[data-faq-hidden]');
    if (!toggleEl || !hiddenFaqEls.length || toggleEl.dataset.faqInitialized === 'true') return;

    toggleEl.dataset.faqInitialized = 'true';
    toggleEl.addEventListener('click', () => {
      const isExpanded = toggleEl.getAttribute('aria-expanded') === 'true';

      hiddenFaqEls.forEach(faq => faq.classList.toggle('hidden', isExpanded));
      toggleEl.setAttribute('aria-expanded', !isExpanded);
      toggleEl.textContent = isExpanded ? toggleEl.dataset.faqShowText : toggleEl.dataset.faqHideText;

      if (isExpanded) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
};

export default initFaqs;
